import { InjectionToken } from '@angular/core';

import { Logger } from '@app/services';

export interface NetworkRepository {
  getLogger(): Logger;
  hasServerConnection(maxRetries: number, requestTimeout: number, noRetry: boolean): Promise<boolean>;
}

export const NETWORK_REPOSITORY = new InjectionToken<NetworkRepository>('NETWORK_REPOSITORY');
